export const SET_NOTICE = "NOTIFICATIONS/SET_NOTICE";
export const CLEAR_NOTICE = "NOTIFICATIONS/CLEAR_NOTICE";

export const clearNotice = () => {
  return {
    type: CLEAR_NOTICE,
  };
};
export const setNotice = notice => {
  return {
    type: SET_NOTICE,
    notice,
  };
};
